import React, { Component } from 'react';

export default class FailedCancellation extends Component {
  static propTypes = {};

  render() {
    return (
      <div className="cancellation-failed-cancellation content-container kupos-card">
        <div className="font13">
          ¿Qué puedes&nbsp;<span className="bold-text">hacer?</span>
        </div>

        <div className=" display-flex icon-text-section font11">
          <img src="/images/icon_whatsapp.png" alt={this.props.t('TRANSLATIONS.ICON_WHATSAPP')} />
          <span>
            Si estás presentando algún problema con tu cancelación, por favor envíanos un correo a{' '}
            <span className="bold-text">clientes@pullmanbus.cl</span> o contáctanos por WhatsApp o
            teléfono al <span className="bold-text">+56 9 4915 6683</span>.{' '}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/cancellation/FailedCancellation.js